import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'styled-components'
import Tooltip from 'components/Tooltip'
import { ListButton, PopupProvider } from 'components'
import { AnchorPositions, PopupDirections } from 'constants/enums'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'
import { browserHelpers } from 'utils'
import {
  DropdownListItemTitle,
  DropdownListItemDescription
} from './ReleaseDownloadDropdown.styles'
import { ActionButton as DefaultActionButton } from 'components/ReleaseCard/ReleaseCard.styles'
import { Download } from '@dsny/dsny-component-library/icons'

export default function ReleaseDownloadDropdown({
  release,
  onDownloadRelease,
  ButtonComponent,
  iconSize = 24
}) {
  const { t } = useTranslation()
  const theme = useTheme()
  const responsiveBreakpointsVersion = useResponsiveBreakpointsVersion()
  const responsiveBreakpointsV2 =
    responsiveBreakpointsVersion === RESPONSIVE_BREAKPOINT_VERSIONS.V2
  const isDownloadAllowed =
    release?.candownload && browserHelpers.browserAllowsDownload

  const Button = ButtonComponent || DefaultActionButton

  return (
    <>
      {browserHelpers.browserAllowsDownload && (
        <PopupProvider
          tapOutSideToDismiss
          anchorPosition={AnchorPositions.bottomCenter}
          popupDirection={PopupDirections.downCenter}
          renderTrigger={({ setOnOff }) => {
            return (
              <Tooltip
                hasArrow={false}
                placement="top"
                text={
                  release?.candownload
                    ? t('release-list.download-all')
                    : t('release-list.download-unavailable')
                }
              >
                <Button
                  $responsiveBreakpointsV2={responsiveBreakpointsV2}
                  variant="primary"
                  setting="player"
                  disabled={!release?.candownload}
                  mode="dark"
                  style={{
                    marginRight: 12,
                    marginLeft: 12
                  }}
                  onClick={(e) => {
                    e.stopPropagation()
                    setOnOff(true)
                  }}
                >
                  <Download
                    width={iconSize}
                    height={iconSize}
                    color={theme.colors.black0}
                  />
                </Button>
              </Tooltip>
            )
          }}
        >
          <div
            className="rounded overflow-y-auto max-h-64 scrollbar-blue"
            style={{
              paddingTop: 8,
              paddingBottom: 8,
              width: 170,
              boxShadow: '0px 0px 8px 0px #00000040',
              background: theme.colors.neutralW20,
              border: `.5px solid ${theme.colors.neutralW30}`
            }}
          >
            {isDownloadAllowed && (
              <>
                <ListButton
                  key={1}
                  render={() => {
                    return (
                      <>
                        <DropdownListItemTitle>
                          {t('general.download-all-wav')}
                        </DropdownListItemTitle>
                        <DropdownListItemDescription>
                          {t('general.download-all-tracks-as-wav')}
                        </DropdownListItemDescription>
                      </>
                    )
                  }}
                  onClick={() => onDownloadRelease('wav')}
                />
                <ListButton
                  key={2}
                  render={() => {
                    return (
                      <>
                        <DropdownListItemTitle>
                          {t('general.download-all-mp3')}
                        </DropdownListItemTitle>
                        <DropdownListItemDescription>
                          {t('general.download-all-tracks-as-mp3')}
                        </DropdownListItemDescription>
                      </>
                    )
                  }}
                  onClick={() => onDownloadRelease('mp3')}
                />
              </>
            )}
          </div>
        </PopupProvider>
      )}
    </>
  )
}
